import { useCallback, useState } from 'react'

const useToggle = (initialValue = false) => {
  const [state, setState] = useState<boolean>(initialValue)
  const toggle = useCallback(() => {
    setState((prevState) => !prevState)
  }, [])
  return [state, toggle] as const
}

export default useToggle
